import PropTypes from 'prop-types';
import { appendQueryString, getQueryObject, isBrowser, ROUTES } from 'Utils';
import * as analytics from 'Utils/analytics';
const { EVENTS } = analytics;

const VerificationSent = (props) => {
  const { strings, email } = props;
  const backToLogin = () => {
    analytics.event({ action: EVENTS.resendBack, label: 'resendBack' });
    const route =
      getQueryObject(props)?.redirectTo ??
      appendQueryString(ROUTES.PAGE_HOME.url);
    window.location.href = route;
  };

  return (
    <div className="centered row">
      <div className="main">
        <h1 className="page-heading">{strings.verificationSent}</h1>
        <p>
          {isBrowser()
            ? strings.verificationSentMessage.formatUimTranslation(email)
            : ''}
        </p>
        <button onClick={backToLogin}>{strings.verificationBackToLogin}</button>
      </div>
    </div>
  );
};

VerificationSent.propTypes = {
  email: PropTypes.string.isRequired,
  strings: PropTypes.object.isRequired,
};

export default VerificationSent;
